import { render, staticRenderFns } from "./PageSelectMenuPageItem.vue?vue&type=template&id=ed3be310"
import script from "./PageSelectMenuPageItem.vue?vue&type=script&lang=js"
export * from "./PageSelectMenuPageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports